var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 100,
    height: 100,
    viewBox: "0,0,256,256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#a92424",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.12,5.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,4c-2.74952,0 -5,2.25048 -5,5v32c0,2.74952 2.25048,5 5,5h32c2.74952,0 5,-2.25048 5,-5v-32c0,-2.74952 -2.25048,-5 -5,-5zM9,6h32c1.66848,0 3,1.33152 3,3v32c0,1.66848 -1.33152,3 -3,3h-32c-1.66848,0 -3,-1.33152 -3,-3v-32c0,-1.66848 1.33152,-3 3,-3zM18.07617,18c-0.705,0.097 -1.50967,0.48345 -2.01367,1.06445c-0.504,0.58 -0.80747,1.25855 -0.60547,1.93555c0.805,0 1.51162,-0.38775 2.01563,-0.96875c0.403,-0.484 0.70452,-1.25725 0.60352,-2.03125zM26.80078,18l-1.80078,0.5v2.5h-1.5v1.375h1.5v5.22461c0,1.2 0.19922,1.99961 0.69922,2.59961c0.5,0.5 1.2,0.80078 2,0.80078c0.7,0 1.30156,-0.09922 1.60156,-0.19922l-0.10156,-1.40039c-0.2,0.1 -0.5,0.09961 -1,0.09961c-1.1,0 -1.39844,-0.70039 -1.39844,-1.90039v-5.22461h2.59961v-1.375h-2.59961zM13.3418,21c-1.008,0 -2.0157,0.59961 -2.7207,1.59961c-1.007,1.5 -0.80592,4.29961 0.70508,6.59961c0.504,0.9 1.2098,1.80078 2.2168,1.80078c0.907,0.1 1.10741,-0.5 2.31641,-0.5c1.108,-0.1 1.3098,0.5 2.2168,0.5c0.907,0 1.71241,-1.10039 2.31641,-1.90039c0.303,-0.6 0.50425,-0.89961 0.90625,-1.59961c-2.216,-0.9 -2.61834,-3.99922 -0.40234,-5.19922c-0.705,-0.8 -1.61058,-1.30078 -2.51758,-1.30078c-1.208,0 -1.71353,0.59961 -2.51953,0.59961c-0.806,0 -1.50958,-0.59961 -2.51758,-0.59961zM30.625,21l3.78906,10h1.69531l3.89063,-10h-1.89453l-1.89453,5.59961c-0.299,1 -0.59983,1.79961 -0.79883,2.59961h-0.09961c-0.2,-0.9 -0.49788,-1.69961 -0.79687,-2.59961l-1.99609,-5.59961z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1824931d2a8fc9eb6a2f5b5f3b4d7f57.svg";
export { ForwardRef as ReactComponent };